
export default {
    spacingDebug: true,
    components: {
        HeaderTemplate: () => import("~/components/global/templates/HeaderTemplate"),
        CardDeckTemplate: () => import("~/components/global/templates/CardDeckTemplate"),
    },
    props: {
        sectionId: {
            type: String,
            default: "claims-support",
        },
        payload: {
            type: Object,
            default: () => ({}),
        },
    },
    computed: {
        sectionHeading() {
            const heading = this.payload?.heading || {};

            return {
                level: heading.level || "h2",
                textContent: heading.textContent || "",
                alignment: heading.alignment || "center",
            };
        },
        items() {
            const sourceItems = this.payload?.body?.items;
            if (!Array.isArray(sourceItems)) return [];

            return sourceItems
                .map((item) => {
                    const image = item?.thumbnail?.image;

                    return {
                        title: item?.heading?.textContent || "",
                        description: item?.body?.textContent || "",
                        image: image?.src || "",
                        imageAlt: image?.alt || "",
                        url: image?.url || "",
                    };
                })
                .filter((item) => item.title && item.url);
        },
    },
};
